export const getCardInputIframeUrl = (env) => {
  switch (env) {
    case 'PROD':
      return 'https://cdn.payair.com/srci-card-inputs/2.1.0/'
    case 'QA':
      return 'https://qa.cdn.payair.com/srci-card-inputs/2.1.0/'
    default:
      return 'https://dev.cdn.payair.com/srci-card-inputs/2.1.0-dev/'
  }
}
